// extracted by mini-css-extract-plugin
module.exports = {"label":"Switcher_label__XBspN","checkbox":"Switcher_checkbox__1gIqQ"};